import { render, staticRenderFns } from "./orderCancel.vue?vue&type=template&id=0a0c30a6&scoped=true"
import script from "./orderCancel.vue?vue&type=script&lang=ts"
export * from "./orderCancel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0c30a6",
  null
  
)

export default component.exports